
import { Toast } from 'vant';
import { Message, Loading } from 'element-ui';
import store from '@/store'

let isMobile = store?.state.isMobile || localStorage.getItem('isMobile') === "true"

let loadingInstance = null
let msgData = Message
let type = 'error'

if (isMobile) {
	msgData = Toast
	type = 'fail '
}

// 封装提示方法
const main = {
	msgData,
	//成功
	success(msg, options = {}) {
		if (!msg) {
			console.error('消息提示内容不能为空!')
			return
		}
		if (isMobile) {
			msgData.clear()
		}
		msgData({
			message: msg,
			type: 'success',
			...options
		})
	},
	//失败
	error(msg, options = {}) {
		// console.log(isMobile)
		if (!msg) {
			console.error('消息提示内容不能为空!')
			return
		}
		if (isMobile) {
			msgData.clear()
		}
		msgData({
			message: msg,
			type,
			...options
		})
	},
	showLoading(msg = '') {
		if (isMobile) {
			msgData.clear()
			msgData.loading({
				message: msg,
				forbidClick: true,
				duration: 0
			})
		} else {
			loadingInstance = Loading.service({
				lock: true,
				text: msg,
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.3)'
			})
		}
	},
	closeLoading() {
		if (isMobile) {
			msgData.clear()
		} else {
			if (loadingInstance) {
				loadingInstance.close()
				loadingInstance = null
			}
		}
	},
	//重置
	init() {
		isMobile = store.state.isMobile
		if (isMobile) {
			msgData = Toast
			type = 'fail '
		} else {
			msgData = Message
			type = 'error'
		}
	}
}

export default main